var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.payee?.shopEnabled)?_c('div',{staticClass:"h-100 position-relative"},[_c('Catalogs')],1):_c('div',{staticClass:"shop-baner"},[_c('i',{staticClass:"far fa-store"}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('shop.thisWillBeAShop'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }